module.exports = __webpack_public_path__ + "img/Logo-26.32e84228.svg";